/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillingStatusDto } from '../../models/billing-status-dto';

export interface BillingControllerGetBillingStatus$Params {
}

export function billingControllerGetBillingStatus(http: HttpClient, rootUrl: string, params?: BillingControllerGetBillingStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingStatusDto>> {
  const rb = new RequestBuilder(rootUrl, billingControllerGetBillingStatus.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BillingStatusDto>;
    })
  );
}

billingControllerGetBillingStatus.PATH = '/billing/status';
